<template></template>

<script>
export default {
  data() {
    return {
      thingTimerId: null,
      thingTimerSetting: {
        enabled: false,
        interval: 300000,
      },
    };
  },
  computed: {
    visualizationPinTypes: ({ $store }) => $store.state.map.visualizationPinTypes,
    currentFloorId: ({ $store }) => $store.state.current.floorId,
  },
  watch: {
    visualizationPinTypes(newValue) {
      this.updateTimerSetting(newValue);
    },
    thingTimerSetting(newValue, oldValue) {
      if (newValue.enabled && !oldValue.enabled) {
        this.startThingUpdate(newValue.interval);
      } else if (!newValue.enabled && oldValue.enabled) {
        this.stopThingUpdate();
      } else if (newValue.enabled && newValue.interval !== oldValue.interval) {
        this.stopThingUpdate();
        this.startThingUpdate(newValue.interval);
      }
    },
  },
  beforeDestroy() {
    this.stopThingUpdate();
  },
  methods: {
    updateTimerSetting(visualizationPinTypes) {
      this.updateThingTimerSetting(visualizationPinTypes, visualizationPinTypes);
    },
    updateThingTimerSetting(visualizationPinTypes) {
      const isThingNeededUpdateEvery10s = visualizationPinTypes.includes('persons');

      this.thingTimerSetting = {
        enabled: isThingNeededUpdateEvery10s,
        interval: 10000,
      };
    },
    startThingUpdate(interval) {
      this.thingTimerId = setInterval(() => {
        this.$store.dispatch('area/getFloorThingExTagsInBackground', this.currentFloorId);
      }, interval);
    },
    stopThingUpdate() {
      clearInterval(this.thingTimerId);
      this.thingTimerId = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// automatic_area_updater.vue?f9edbf0c